import { Avatar, Badge } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  small: {
    position: 'relative',
    zIndex: 0,
    width: theme.spacing(5),
    height: theme.spacing(5)
  },
  medium: {
    position: 'relative',
    zIndex: 0,
    width: theme.spacing(7),
    height: theme.spacing(7)
  },
  large: {
    position: 'relative',
    zIndex: 0,
    width: theme.spacing(9),
    height: theme.spacing(9)
  }
}));

const getSize = (size: Size) => {
  const classes = useStyles();
  switch (size) {
    case 'small':
      return classes.small;
    case 'large':
      return classes.large;
    default:
      return classes.medium;
  }
};

type Size = 'small' | 'medium' | 'large';

interface IProps {
  id?: number;
  className?: string;
  label: string;
  size?: Size;
  value?: string;
  name?: string;
  icon?: any;
  accept?: string;
  onChange: (file?: File) => void;
}

const UserPhotoField = ({
  className = '',
  label,
  size = 'medium',
  value,
  icon,
  accept,
  onChange,
  id
}: IProps) => {
  const avatar = `/api/files/bypath/${value}`;

  const handleChange = (e: any) => {
    if (e?.target) {
      let file: File = e.target.files[0];
      onChange && onChange(file);
      e.target.value = null;
    }
  };

  const handleRemove = () => {
    onChange && onChange(undefined);
  };
  const renderBadgeContent = () => {
    return (
      <div
        onClick={handleRemove}
        className="transform cursor-pointer font-semibold text-white hover:scale-125"
      >
        x
      </div>
    );
  };
  return (
    <div className={classNames(['mb-4', { [className]: !!className }])}>
      <label className="text-sm font-medium text-gray-700">{label}</label>
      <div className={classNames(['flex items-center gap-8'])}>
        <Badge
          badgeContent={!!value && renderBadgeContent()}
          color={!!value ? 'error' : 'default'}
          overlap="circular"
        >
          <Avatar
            className={getSize(size)}
            src={!id ? value : id && !!value?.includes('base64,') ? value : value && avatar}
          >
            {icon}
          </Avatar>
        </Badge>
        <input
          id="upload-input"
          data-testid="upload-input"
          type="file"
          onChange={handleChange}
          accept={accept}
          hidden
        />
        {process.env.isClick && (
          <label htmlFor="upload-input" className="btn cursor-pointer">
            Upload
          </label>
        )}
      </div>
    </div>
  );
};

export default UserPhotoField;
